module.exports = __webpack_public_path__ + "media/custom-font-icon/icomoon-0143cca5.svg";